/**
 * Project crew line-ups for legend hovers. One fetch per class and project, shared by every
 * performance and maneuver legend on the page.
 */
import { warn } from "./console";
import { refreshTaggerCrewRoster } from "../services/taggerCrewRoster";
import type { CrewRosterRow } from "../services/crewRosterService";
import type { CrewRow } from "../services/crewService";

export interface CrewDirectory {
  crews: CrewRow[];
  roster: CrewRosterRow[];
}

const cache = new Map<string, Promise<CrewDirectory>>();

export function loadCrewDirectory(className: string, projectId: number): Promise<CrewDirectory> {
  const key = `${className.trim().toLowerCase()}|${projectId}`;
  const existing = cache.get(key);
  if (existing) {return existing;}
  const pending = refreshTaggerCrewRoster(projectId, className)
    .then((data): CrewDirectory => ({ crews: data.crews, roster: data.roster }))
    .catch((err: unknown) => {
      cache.delete(key);
      warn("[crewDirectory] Failed to load crews", err);
      return { crews: [], roster: [] };
    });
  cache.set(key, pending);
  return pending;
}
